"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCodePopup = void 0;
var DOMHelper_1 = require("./DOMHelper");
var InputCodePopup = /** @class */ (function () {
  function InputCodePopup(title, onSuccess, onClose) {
    var _this = this;
    var _a, _b, _c;
    this.title = "";
    /**contain the entered code */
    this.inputCode = [];
    this.inputIndex = 0;
    /**once code is completed, put it at true */
    this.codeCompleted = false;
    this.onKey = function (key) {
      switch (key) {
        case "Cancel":
        case "Escape":
          _this.destroy();
          break;
        case "Backspace":
          _this.inputIndex > 0 ? _this.backspace() : _this.destroy();
          break;
        default:
          if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(key) && !_this.codeCompleted) {
            _this.inputIndex++;
            _this.addDigit(key);
          }
          break;
      }
      return true;
    };
    this.onSuccess = onSuccess;
    this.onClose = onClose;
    //create popup
    var parent =
      (_b = document.getElementById((_a = _LogContext.logConfig.rootElementId) !== null && _a !== void 0 ? _a : "")) !==
        null && _b !== void 0
        ? _b
        : DOMHelper_1.DOMHelper.getBody();
    this.domTree =
      (_c = document.getElementById("codePopup")) !== null && _c !== void 0
        ? _c
        : DOMHelper_1.DOMHelper.createElementWithParent("div", parent, "codePopup");
    this.domTitle = DOMHelper_1.DOMHelper.createDivWithParent(this.domTree, null, "title", this.title);
    this.codeLine = DOMHelper_1.DOMHelper.createElementWithParent("ul", this.domTree, null, "codeLine");
    this.input1 = DOMHelper_1.DOMHelper.createElementWithParent("li", this.codeLine, null, "input");
    this.input2 = DOMHelper_1.DOMHelper.createElementWithParent("li", this.codeLine, null, "input");
    this.input3 = DOMHelper_1.DOMHelper.createElementWithParent("li", this.codeLine, null, "input");
    this.input4 = DOMHelper_1.DOMHelper.createElementWithParent("li", this.codeLine, null, "input");
    this.span1 = DOMHelper_1.DOMHelper.createElementWithParent("span", this.input1);
    this.span2 = DOMHelper_1.DOMHelper.createElementWithParent("span", this.input2);
    this.span3 = DOMHelper_1.DOMHelper.createElementWithParent("span", this.input3);
    this.span4 = DOMHelper_1.DOMHelper.createElementWithParent("span", this.input4);
    //style
    this.domTree.style.zIndex = "999";
    this.domTree.style.position = "absolute";
    this.domTree.style.width = "700px";
    this.domTree.style.height = "380px";
    this.domTree.style.left = "50%";
    this.domTree.style.top = "50%";
    this.domTree.style.transform = "translate(-50%,-50%)";
    this.domTree.style.borderRadius = "20px";
    this.domTree.style.fontFamily = "Heebo, sans-serif";
    this.domTree.style.border = "solid #333";
    //title
    this.domTitle.style.fontSize = "30px";
    this.domTitle.style.textAlign = "center";
    this.domTitle.style.paddingTop = "40px";
    this.domTitle.innerText = title;
    //line
    this.codeLine.style.listStyleType = "none";
    this.codeLine.style.justifyContent = "space-around";
    this.codeLine.style.width = "80%";
    this.codeLine.style.margin = "auto";
    this.codeLine.style.marginTop = "50px";
    //input
    var inputs = [this.input1, this.input2, this.input3, this.input4];
    inputs.forEach(function (input) {
      input.style.backgroundColor = "rgb(252,252,252)";
      input.style.float = "left";
      input.style.marginRight = "40px";
      input.style.width = "100px";
      input.style.height = "200px";
      input.style.borderRadius = "20px";
      input.style.fontFamily = "Heebo, sans-serif";
      input.style.color = "rgb(32,32,32)";
    });
    //span
    var spans = [this.span1, this.span2, this.span3, this.span4];
    spans.forEach(function (span) {
      span.style.fontSize = "80px";
      span.style.display = "block";
      span.style.textAlign = "center";
      span.style.position = "relative";
      span.style.top = "50px";
    });
    if (_LogContext.logConfig.lightUI) {
      //page
      this.domTree.style.backgroundColor = "#e7e7e7";
      this.domTree.style.boxShadow = "0 10px 50px black";
      this.domTree.style.color = "rgb(20,20,20)";
      //title
      this.domTitle.style.color = "rgb(3,3,3)";
      //line
      this.codeLine.style.color = "rgb(3,3,3)";
    } else {
      //page
      this.domTree.style.backgroundColor = "rgb(20,22,24)";
      this.domTree.style.boxShadow = "0 10px 50px black";
      this.domTree.style.color = "rgb(85,85,85)";
      //title
      this.domTitle.style.color = "rgb(252, 252, 252)";
      //code line
      this.codeLine.style.color = "rgb(252,252,252)";
      //input
      var inputs_1 = [this.input1, this.input2, this.input3, this.input4];
      inputs_1.forEach(function (input) {
        input.style.backgroundColor = "rgb(252,252,252)";
        input.style.color = "rgb(32,32,32)";
      });
    }
    this.input1.style.boxShadow = "0 0 20px red";
  }
  InputCodePopup.prototype.destroy = function () {
    var _a;
    (_a = this.domTree) === null || _a === void 0 ? void 0 : _a.remove();
    this.inputIndex = 0;
    this.onClose();
  };
  InputCodePopup.prototype.backspace = function () {
    switch (this.inputIndex) {
      case 1:
        this.span1.innerHTML = "";
        this.input2.style.boxShadow = "";
        this.input1.style.boxShadow = "0 0 20px red";
        break;
      case 2:
        this.span2.innerHTML = "";
        this.input3.style.boxShadow = "";
        this.input2.style.boxShadow = "0 0 20px red";
        break;
      case 3:
        this.span3.innerHTML = "";
        this.input4.style.boxShadow = "";
        this.input3.style.boxShadow = "0 0 20px red";
        break;
      default:
        break;
    }
    this.inputIndex -= 1;
  };
  InputCodePopup.prototype.addDigit = function (digit) {
    var _a;
    switch (this.inputIndex) {
      case 1:
        this.span1.innerHTML = digit;
        this.input1.style.boxShadow = "";
        this.input2.style.boxShadow = "0 0 20px red";
        this.inputCode[this.inputIndex] = digit;
        break;
      case 2:
        this.span2.innerHTML = digit;
        this.input2.style.boxShadow = "";
        this.input3.style.boxShadow = "0 0 20px red";
        this.inputCode[this.inputIndex] = digit;
        break;
      case 3:
        this.span3.innerHTML = digit;
        this.input3.style.boxShadow = "";
        this.input4.style.boxShadow = "0 0 20px red";
        this.inputCode[this.inputIndex] = digit;
        break;
      case 4:
        this.span4.innerHTML = digit;
        this.input4.style.boxShadow = "";
        this.inputCode[this.inputIndex] = digit;
        this.codeCompleted = true;
        (_a = this.onSuccess) === null || _a === void 0 ? void 0 : _a.call(this, this.inputCode.join(""));
        this.destroy();
        break;
      default:
        break;
    }
  };
  return InputCodePopup;
})();
exports.InputCodePopup = InputCodePopup;
//# sourceMappingURL=inputCodePopup.js.map
